function dlesubscribingGetUserHash () {
  if (typeof dle_login_hash !== 'undefined' && dle_login_hash) return dle_login_hash
  if (typeof window !== 'undefined' && window.dlesubscribing_user_hash) return window.dlesubscribing_user_hash
  return ''
}

$(function () {
  $(document).on('click', '.js-open-tariffs', function (e) {
    e.preventDefault()
    window.location.href = '/tariffs.html'
  })

  $('#autopay_btn').on('click', function () {
    autoPayAjax()
  })

  $('#delcard').on('click', function () {
    showDialog('#delcardpopup', 'Отвязка карты', 'Отмена', 'Отвязать', delCardAjax)
  })

  $('#addcard').on('click', function () {
    showDialog('#addcardpopup', 'Привязка карты', 'Отмена', 'Продолжить', showAddCardPaymentMethodDialog)
  })

  function showDialog (id, title, notConfirmText, confirmText, ajaxFunction) {
    $(function () {
      $(id).dialog({
        autoOpen: true,
        modal: true,
        width: 736,
        title: title,
        buttons: [
          {
            text: notConfirmText,
            click: function () {
              $(this).dialog('close')
            }
          },
          {
            text: confirmText,
            click: function () {
              ajaxFunction()
              $(this).dialog('close')
            }
          }
        ]
      })
    })
  }

  function autoPayAjax () {
    sendAjax('/engine/ajax/dlesubscribing.php', { action: 'autopay' }, function () {
      location.reload()
    })
  }

  function delCardAjax () {
    sendAjax('/engine/ajax/dlesubscribing.php', { action: 'delcard' }, function () {
      location.reload()
    })
  }

  function showAddCardPaymentMethodDialog () {
    $('#dlepopup_addcard_payment_method').remove()

    const message = ''
        + "<div class='subscription-payment-dialog'>"
        + "<div class='pay-type-list'>"
        + "<a href='#' id='dlesub-addcard-pay-rub' class='button gray pay-type-list-link'>Банковская карта <div class='pay-system'><i class='icon-mir'></i><i class='icon-visa'></i><i class='icon-mstrcard'></i><span class='pay-currency'>RUB</span></div></a>"
        + "<a href='#' id='dlesub-addcard-pay-foreign' class='button gray pay-type-list-link'>Зарубежная карта <div class='pay-system'><i class='icon-visa'></i><i class='icon-mstrcard'></i><span class='pay-currency'>USD, EUR</span></div></a>"
        + '</div>'
        + "<div class='subscription-support-dialog'>"
        + "<p style='margin:0;'>Если что-то пошло не так, обратитесь в службу технической поддержки <a href='mailto:support@inoriginal.cc?subject=Обращение%20в%20службу%20поддержки' style='white-space:nowrap;'>support@inoriginal.cc</a> или в <a href='https://t.me/inoriginal_support' target='_blank' rel='noopener noreferrer'>Telegram</a>, <a href='https://vk.com/write-178980769' target='_blank'>Вконтакте</a>.</p>"
        + '</div>'
        + '</div>'

    $('body').append("<div id='dlepopup_addcard_payment_method' class='dle-alert' title='Выберите способ оплаты' style='display:none'>" + message + '</div>')

    let popupWidth = 500
    const maxWidth = $(window).width() * 0.95
    if (popupWidth > maxWidth) popupWidth = maxWidth

    $('#dlepopup_addcard_payment_method').dialog({
      modal: true,
      autoOpen: true,
      width: popupWidth,
      resizable: false,
      dialogClass: 'modalfixed dle-popup-alert dle-popup-payment-method'
    })

    $('.modalfixed.ui-dialog').css({ position: 'fixed' })
    $('#dlepopup_addcard_payment_method').dialog('option', 'position', { my: 'center', at: 'center', of: window })

    $('#dlesub-addcard-pay-rub').on('click', function (e) {
      e.preventDefault()
      $('#dlepopup_addcard_payment_method').dialog('close')
      $('#dlepopup_addcard_payment_method').remove()
      addCardAjax('RUB')
    })

    $('#dlesub-addcard-pay-foreign').on('click', function (e) {
      e.preventDefault()
      $('#dlepopup_addcard_payment_method').dialog('close')
      $('#dlepopup_addcard_payment_method').remove()
      addCardAjax('USD')
    })
  }

  function addCardAjax (currency) {
    sendAjax('/engine/ajax/dlesubscribing.php', { action: 'addcard', currency: currency || 'RUB' }, function (payment_url) {
      if (typeof payment_url !== 'string' || payment_url.indexOf('http') !== 0) {
        showSubscriptionSupportDialog('Не удалось добавить карту')
        return
      }
      window.location.href = payment_url
    }, function () {
      showSubscriptionSupportDialog('Не удалось добавить карту')
    })
  }

  function sendAjax (url, data, successCallback, errorCallback) {
    data = data || {}
    data.user_hash = dlesubscribingGetUserHash()
    $.ajax({
      url: url,
      type: 'post',
      data: data,
      error: function () {
        if (typeof errorCallback === 'function') {
          errorCallback()
          return
        }
        DLEalert('Если что-то пошло не так, обратитесь в службу технической поддержки <a href=\'mailto:support@inoriginal.cc?subject=Обращение%20в%20службу%20поддержки\' style=\'white-space:nowrap;\'>support@inoriginal.cc</a> или в <a href=\'https://t.me/inoriginal_support\' target=\'_blank\' rel=\'noopener noreferrer\'>Telegram</a>, <a href=\'https://vk.com/write-178980769\' target=\'_blank\'>Вконтакте</a>.', 'Ошибка')
      },
      success: successCallback
    })
  }

  function showSubscriptionSupportDialog (title) {
    $('#dlepopup').remove()

    const message = ''
      + "<div class='subscription-support-dialog'>"
      + "<p style='margin:0;'>Если что-то пошло не так, обратитесь в службу технической поддержки:</p>"
      + "<p style='margin:0;'><a href='mailto:support@inoriginal.cc?subject=Обращение%20в%20службу%20поддержки' style='white-space:nowrap;'>support@inoriginal.cc</a> или в <a href='https://t.me/inoriginal_support' target='_blank' rel='noopener noreferrer'>Telegram</a>, <a href='https://vk.com/write-178980769' target='_blank'>Вконтакте</a>.</p>"
      + '</div>'

    $('body').append("<div id='dlepopup' class='dle-alert' title='" + (title || 'Не удалось оформить подписку') + "' style='display:none'>" + message + '</div>')

    let popupWidth = 560
    const maxWidth = $(window).width() * 0.95
    if (popupWidth > maxWidth) popupWidth = maxWidth

    $('#dlepopup').dialog({
      modal: true,
      autoOpen: true,
      width: popupWidth,
      resizable: false,
      dialogClass: 'modalfixed dle-popup-alert'
    })

    $('.modalfixed.ui-dialog').css({ position: 'fixed' })
    $('#dlepopup').dialog('option', 'position', { my: 'center', at: 'center', of: window })
  }

  $('#promocode_link, #promocode_header').on('click', function () {
    document.body.classList.add('hide')
    $('.promocode-popup-block').addClass('show-block')
    $('html,body').animate({ scrollTop: 0 }, 400)

    setTimeout(function () {
      $('.promocode-popup-block').addClass('show-block_effect')
    }, 200)
  })

  $(document).keydown(function (event) {
    if (event.which == 27) {
      closePromocodePopup()
    }
  })

  function closePromocodePopup () {
    document.body.classList.remove('hide')
    $('.promocode-popup-block').removeClass('show-block')

    setTimeout(function () {
      $('.promocode-popup-block').removeClass('show-block_effect')
    }, 200)
  }

  $('.promocode-popup-close-link').on('click', function () {
    setTimeout(function () {
      $('.promocode-popup-block').removeClass('show-block')
      document.body.classList.remove('hide')
    }, 400)
  })

  $('#promocode_form_btn').on('click', function () {
    $.ajax({

      url: '/engine/ajax/dlesubscribing.php',
      type: 'post',

      data: {
        action: 'promocode',

        promocode: $('#promocode').val(),
        user_hash: dlesubscribingGetUserHash()

      },
      beforeSend: function () {
        $('.promocode-form-wait').show()
      },
      success: function (data) {
        $('.promocode-form-wait').hide()
        $('#promocode_result').html(data)

        setTimeout(function () {
          $('#promocode_result').html('')
        }, 100000)
      },
      error: function () {
        $('.promocode-form-wait').hide()
      }

    })
  })

  $(document).on('click', '#auth_link, #auth_mob_link, #fav_auth_link, #comm_auth_link', function () {
    closeAboutsubPopup()
    closePromocodePopup()
  })

  $(document).on('click', '#aboutsub_link, #aboutsub_link_tariffs, #aboutsub_link_login, #aboutsub_link_footer', function () {
    document.body.classList.add('hide')
    $('.aboutsub-popup-block').addClass('show-block')
    $('html,body').animate({ scrollTop: 0 }, 400)

    setTimeout(function () {
      $('.aboutsub-popup-block').addClass('show-block_effect')
    }, 200)
  })

  $(document).keydown(function (event) {
    if (event.which == 27) {
      closeAboutsubPopup()
    }
  })

  function closeAboutsubPopup () {
    document.body.classList.remove('hide')
    $('.aboutsub-popup-block').removeClass('show-block')

    setTimeout(function () {
      $('.aboutsub-popup-block').removeClass('show-block_effect')
    }, 200)
  }

  $('.aboutsub-popup-close-link').on('click', function () {
    setTimeout(function () {
      $('.aboutsub-popup-block').removeClass('show-block')
      document.body.classList.remove('hide')
    }, 400)
  })

})
